import * as Assets from "Data/Assets";
import * as Topics from "Data/Topics";
import * as HLF from "html-living-framework";
import "pixi-picture";
export abstract class MusicGameSpotlight extends PIXI.Container {
    protected sprite: PIXI.Sprite;
    protected _data: {id: number, name: string};
    protected _subscriptions: any[];

    constructor(pData: {id: number, name: string}) {
        super();
        this._data = pData;
        this.sprite = this.makeSprite();
        this.sprite.visible = false;
        this.addChild(this.sprite);
        this._subscriptions = [
            PubSub.subscribe(Topics.SOLO_QUEUED, this.onMessageReceived.bind(this)),
            PubSub.subscribe(Topics.START_SOLO, this.onMessageReceived.bind(this)),
            PubSub.subscribe(Topics.STOP_SOLO, this.onMessageReceived.bind(this)),
            PubSub.subscribe(Topics.STOP_ALL_SOLOS, this.onMessageReceived.bind(this)),
        ];
    }

    public destroy() {
        super.destroy();
        this._subscriptions.forEach(PubSub.unsubscribe);
    }
    protected onMessageReceived(pTopic: string, pData: any) {
        switch (pTopic) {
            case Topics.SOLO_QUEUED:
                if (pData.character === this._data.id) {
                    this.onSoloQueued(pData);
                }
                break;
            case Topics.START_SOLO:
                if (pData.character === this._data.id) {
                    this.startSolo(pData);
                }
                break;
            case Topics.STOP_SOLO:
                if (pData.character === this._data.id) {
                    this.stopSolo(pData);
                }
                break;
            case Topics.STOP_ALL_SOLOS:
                this.stopSolo(pData);
                break;
        }
    }

    protected abstract startSolo(pData: {character: number, loop: number, bar: number, time: number}): void;
    protected abstract stopSolo(pData: {character: number}): void;
    protected abstract onSoloQueued(pData: {character: number, loop: number}): void;
    protected abstract makeSprite(): PIXI.Sprite;
}